module.exports = __webpack_public_path__ + "assets/alarmicon.29d18589.svg";